module.exports = __webpack_public_path__ + "img/biller.fe1faec.svg";